import {Leaf} from './leaf';

export class Node {

    private _nodeId = 0;
    private _nodeName = '';
    private _node:Node[] = [];
    private _leaf:Leaf[] = [];

    private _path = '';

    constructor(name:string) {
        this._nodeName = name;
    }

    getPath(): string {
        return this._path;
    }

    setPath(value: string) {
        this._path = value;
    }

    getName(): string {
        return this._nodeName;
    }

    setName(value: string) {
        this._nodeName = value;
    }

    getNode(val:string): Node {
        for(const valeur of this._node) {
            if(valeur.getName() === val) {
                return valeur;
            }
        }
    }

    getNodeList():Node[] {
        return this._node;
    }

    getLeaves():Leaf[] {
        return this._leaf;
    }

    setNode(value: Node):Node {
        let tmp:Node = null;
        for(let i=0;i<this._node.length;i++) {
            if(this._node[i].getName() === value.getName()) {
                tmp = this._node[0];
                break;
            }
        }
        if(tmp!=null) {
            return tmp;
        }
        this._node.push(value);

        return value;
    }

    getNodeId(): number {
        return this._nodeId;
    }

    setNodeId(value: number) {
        this._nodeId = value;
    }

    getLeaf(val:string): Leaf {
        for(const value of this._leaf) {
            if(value.getName() === val) {
                return value;
            }
        }
    }

    setLeaf(value: Leaf) {
        this._leaf.push(value);
    }


}
